export default __webpack_public_path__ + "9d4b0edd0e45c3a4b2b960e3a4e10bd8.png";